import React from "react";
import Index from "../../Index";
import PageIndex from "../../../container/PageIndex";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

export default function ActiveDeactiveModal(props) {
  // for delete modal
  const {
    openActiveDeactiveModal,
    handleCloseActiveDeactiveModal,
    updateUserState,
  } = props;
  // const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  // const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  // const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  return (
    <>
      {/* <Index.Button onClick={handleOpenDeleteModal}>Open modal</Index.Button> */}
      <Index.Modal
        open={openActiveDeactiveModal}
        onClose={handleCloseActiveDeactiveModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="common-modal"
      >
        <Index.Box sx={style} className="common-modal-inner delete-modal-inner active-inactive-inner">
          <img
            src={PageIndex.Svg.close}
            className="modal-close-icon"
            onClick={handleCloseActiveDeactiveModal}
            onKeyUp={(e) => {
                
                if (e.key === "Enter") {
                  handleCloseActiveDeactiveModal();
                }
              }}
              tabIndex={0}
            alt=""
            title="Close"
          />
          <Index.Box className="save-draft-modal-content">
            <Index.Typography className="modal-title-text">
              Are you sure you want to Active/Deactive?
            </Index.Typography>
          </Index.Box>
          <Index.Box className="qr-code-generation-section">
            <Index.Box sx={{ width: 1 }} className="grid-main">
              <Index.Box
                display="grid"
                className="display-row"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
              >
                <Index.Box
                  gridColumn={{
                    xs: "span 12",
                    sm: "span 12",
                    md: "span 12",
                    lg: "span 12",
                  }}
                  className="grid-column"
                >
                  <Index.Box className="modal-user-center-btn-flex">
                  
                    <PageIndex.PrimaryButton
                      className="create-user-btn comman-primary-btn"
                      title="Yes"
                      btnLabel="Yes"
                      onClick={updateUserState}
                    />
                      <PageIndex.BorderButton
                      className="cancel-user-btn border-btn"
                      title="No"
                      btnLabel="No"
                      onClick={handleCloseActiveDeactiveModal}
                    />
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Modal>
    </>
  );
}
